import styled, {css} from 'styled-components';
import splashBackgroundImage from 'assets/img/splash-background.jpg';
import splashBackground2xImage from 'assets/img/splash-background@2x.jpg';
import splashBackgroundMobile from 'assets/img/background-mobile-onlinecheckin.jpg';
import splashBackground2xMobile from 'assets/img/background-mobile-onlinecheckin@2x.jpg';
import {device} from 'styled/device';

type WrapperProps = {
  visible: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: fixed;
  height: 100%;
  width: 100%;
  visibility: visible;
  text-align: center;
  background-image: url(${splashBackground2xImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #f7c33a;
  animation-fill-mode: forwards;
  background-position: center;
  cursor: default;
  z-index: 999999;

  ${props =>
    !props.visible &&
    css`
      animation-name: fadeOut;
      animation-duration: 2s;
      pointer-events: none;
    `};

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  @media (max-width: ${device.laptop}) {
    background-image: url(${splashBackgroundImage});
  }

  @media (max-width: ${device.mobileL}) {
    background-image: url(${splashBackground2xMobile});
  }

  @media (max-width: ${device.mobileM}) {
    background-image: url(${splashBackgroundMobile});
  }
`;

export const Text = styled.div`
  position: fixed;
  left: 31%;
  top: 35%;

  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  color: #19194b;
  /* max-width: 270px; */
  text-align: start;
  justify-content: left;

  .smallText {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.4px;
  }
  .largeText {
    font-size: 31px;
    font-weight: 700;
    letter-spacing: -0.62px;
  }

  @media (max-width: ${device.mobileM}) {
    left: 50%;
    top: 5%;
    max-width: 250px;

    .smallText {
      font-size: 18px;
      font-weight: 500;
      letter-spacing: -0.36px;
    }
    .largeText {
      font-size: 28px;
      font-weight: 700;
      letter-spacing: -0.56px;
      line-height: 1.2;
    }
  }
`;
